export function isDashboardLocked(user: {
  modules?: Array<string | { name?: string }>;
  isSubUser?: boolean;
}) {
  return !user.isSubUser && (!Array.isArray(user.modules) || user.modules.length === 0);
}

export function navigationForDashboardState<
  TItem extends { path: string },
  TGroup extends { items: TItem[] },
>(navigation: TGroup[], locked: boolean, homePath: string): TGroup[] {
  if (!locked) return navigation;

  return navigation.flatMap((group) => {
    const items = group.items.filter((item) => item.path === homePath);
    return items.length ? [{ ...group, items }] : [];
  });
}
